import { render, staticRenderFns } from "./planTemplate.vue?vue&type=template&id=5701c20b&scoped=true&"
import script from "./planTemplate.vue?vue&type=script&lang=js&"
export * from "./planTemplate.vue?vue&type=script&lang=js&"
import style0 from "./planTemplate.vue?vue&type=style&index=0&id=5701c20b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701c20b",
  null
  
)

export default component.exports